import FArray from '@/plugins/form/FArray';
import Item from './Item';

export default class extends FArray {
  tour;

  __init = false;

  constructor(props) {
    super(props);
    this.tour = props.parent;
  }

  get data() {
    return this.items.map(i => i.data);
  }

  set data(value) {
    this.__value = [];
    value.forEach((i) => {
      const item = new Item();
      this.push(item);
      item
        .setData(i)
        .init();
    });
  }

  add() {
    const item = new Item();
    item.tariffs.options = this.tour.tariffs.options;
    this.push(item);
    return item.init({
      quota: this.tour.tourData.quota.value,
      time: this.tour.tourData.time.value,
    });
  }

  setTariffOptions() {
    const {options} = this.tour.tariffs;
    this.items.forEach(({tariffs}) => {
      tariffs.options = options;
      if (this.__init) {
        tariffs.set(tariffs.value.filter(tariff => options.find(i => i.value === tariff)));
      }
    });
  }

  init() {
    this.tour.tariffs.$subscribe(() => this.setTariffOptions());
    return super.init()
      .then(() => {
        this.__init = true;
        return this;
      });
  }
}
